var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "819.6px",
    height: "174.1px",
    viewBox: "0 0 819.6 174.1",
    style: {
      enableBackground: "new 0 0 819.6 174.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#1877F2;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M64.1,37.7c-9.6,0-12.4,4.3-12.4,13.7v15.7h25.7l-2.6,25.3H51.7v76.8H20.8V92.4H0V67.1h20.8V51.8 c0-25.5,10.3-39,39-39c6,0,12,0.3,18,1.1v23.8L64.1,37.7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M79.6,114.9c0-28.5,13.5-50,41.8-50c15.4,0,24.9,7.9,29.4,17.8V67.1h29.6v102.1h-29.6v-15.4 c-4.3,9.9-13.9,17.6-29.4,17.6c-28.3,0-41.8-21.4-41.8-50V114.9z M110.4,121.8c0,15.2,5.6,25.3,19.9,25.3c12.7,0,19.1-9.2,19.1-23.8 V113c0-14.6-6.4-23.8-19.1-23.8c-14.4,0-19.9,10.1-19.9,25.3V121.8z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M244.7,64.9c12,0,23.4,2.6,29.6,6.9l-6.9,21.9c-6.4-3.1-13.5-4.7-20.6-4.7c-16.7,0-24,9.6-24,26.2v6 c0,16.5,7.3,26.2,24,26.2c7.1,0,14.2-1.7,20.6-4.7l6.9,21.9c-6.2,4.3-17.6,6.9-29.6,6.9c-36.2,0-52.8-19.5-52.8-50.8v-4.7 C191.9,84.4,208.4,64.9,244.7,64.9z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M278.4,122v-9c0-28.9,16.5-48,50.2-48c31.7,0,45.7,19.3,45.7,47.6v16.3h-65c0.7,13.9,6.9,20.2,24,20.2 c11.6,0,23.8-2.4,32.8-6.2l5.7,21.1c-8.2,4.3-24.9,7.5-39.7,7.5C292.9,171.5,278.4,152,278.4,122z M309.2,108.7h37.3v-2.6 c0-11.1-4.5-20-18-20C314.6,86.1,309.2,94.9,309.2,108.7L309.2,108.7z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M488.7,121.3c0,28.5-13.7,50-42,50c-15.4,0-26.2-7.7-30.5-17.6v15.4h-29.2V15.8L418,13v68.2 c4.5-9,14.4-16.3,28.7-16.3c28.3,0,42,21.4,42,50L488.7,121.3z M457.8,114.2c0-14.4-5.6-25.1-20.4-25.1c-12.7,0-19.5,9-19.5,23.6 v10.7c0,14.6,6.9,23.6,19.5,23.6c14.8,0,20.4-10.7,20.4-25.1V114.2z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M499,120.7v-5.1c0-29.4,16.7-50.6,50.8-50.6s50.8,21.2,50.8,50.6v5.1c0,29.4-16.7,50.6-50.8,50.6 S499,150.1,499,120.7z M569.8,113.4c0-13.5-5.6-24.2-20-24.2s-20,10.7-20,24.2v9.4c0,13.5,5.6,24.2,20,24.2s20-10.7,20-24.2V113.4z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M611,120.7v-5.1c0-29.4,16.7-50.6,50.8-50.6s50.8,21.2,50.8,50.6v5.1c0,29.4-16.7,50.6-50.8,50.6 S611,150.1,611,120.7z M681.8,113.4c0-13.5-5.6-24.2-20-24.2s-19.9,10.7-19.9,24.2v9.4c0,13.5,5.6,24.2,19.9,24.2s20-10.7,20-24.2 V113.4z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M755.1,115.7l30.5-48.7h32.8l-32,50.4l33.2,51.7h-32.8l-31.7-50v50h-30.9V15.8l30.9-2.8V115.7z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.cfbbde5c0a10b3881c8189b68254b827.svg";
export { ForwardRef as ReactComponent };